<template>
  <div class="center-table-wrapper">
    <!-- 标题 -->
    <div class="title-box">
      <span
        class="title"
        :class="{ clickable: isProductionReport }"
        @click="goToProductionReport"
        >{{ title }}</span
      >
    </div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="col-1">医院名称</div>
      <div class="col-2">织物总量</div>
      <div class="col-3">安全库存</div>
      <div class="col-4">今日污衣洗涤</div>
      <div class="col-5">今日净衣配送</div>
    </div>

    <!-- 表格内容 -->
    <div
      class="table-body"
      :class="{ 'is-scrolling': shouldScroll }"
      :style="{ maxHeight: `${visibleRows * rowHeight}px` }"
    >
      <div class="scroll-wrapper" :class="{ 'is-animating': shouldScroll }">
        <div
          v-for="(item, index) in scrollList"
          :key="item.hospitalId + '_' + index"
          class="table-row"
        >
          <div
            class="col-1 hospital-name"
            :title="item.hospitalName"
            @click="goToIndex2(item)"
          >
            {{ item.hospitalName || "-" }}
          </div>
          <div class="col-2">{{ item.fabricCount || 0 }}</div>
          <div class="col-3">{{ item.safeStock || 0 }}</div>
          <div class="col-4">{{ item.todayDirtyWash || 0 }}</div>
          <div class="col-5">{{ item.todayCleanDelivery || 0 }}</div>
        </div>
      </div>
      <div v-if="displayList.length === 0" class="empty-tip">数据加载中</div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";

export default {
  name: "CenterTable",
  props: {
    title: {
      type: String,
      default: "医院织物流通实时数据统计",
    },
  },
  data() {
    return {
      displayList: [],
      originalList: [],
      intervalId: null,
      visibleRows: 7,
      rowHeight: 42,
      isProductionReport: false,
    };
  },
  computed: {
    shouldScroll() {
      return this.originalList.length > this.visibleRows;
    },
    scrollList() {
      if (!this.shouldScroll) {
        return this.displayList;
      }
      return [...this.displayList, ...this.displayList];
    },
  },
  mounted() {
    this.getData();
    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 1000);

    this.isProductionReport =
      this.title && this.title.includes("医院织物流通实时数据");
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getData() {
      const res = await api.getBigSkuCustomerNew();

      if (res.ResultCode != 0) return;

      const data = res.Result || [];

      const processedData = data.map((item) => ({
        hospitalId: item.customerId,
        hospitalName: item.customerName || "-",
        fabricCount: item.skuNum || 0,
        safeStock: item.stockNum || 0,
        todayDirtyWash: item.numReceive || 0,
        todayCleanDelivery: item.numDelivery || 0,
      }));

      this.originalList = processedData;
      this.displayList = processedData;
    },
    goToIndex2(item) {
      if (!item.hospitalName || item.hospitalName === "-") return;
      this.$router.push({
        path: "/index2",
        query: { customerName: item.hospitalName, customerId: item.hospitalId },
      });
    },
    goToProductionReport() {
      if (!this.isProductionReport) return;
      this.$router.push("/productionReport");
    },
  },
};
</script>

<style lang="scss" scoped>
.center-table-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;

  .title-box {
    flex-shrink: 0;
    padding-bottom: 10px;
    padding-top: 20px;
    .title {
      font-size: 18px;
      color: #00cdff;

      &.clickable {
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #00cdff;
        }
      }
    }
  }

  .table-header {
    display: flex;
    flex-shrink: 0;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 18px;
    color: #8e9eae;

    .col-1 {
      width: 20%;
    }
    .col-2 {
      width: 20%;
      text-align: center;
    }
    .col-3 {
      width: 20%;
      text-align: center;
    }
    .col-4 {
      width: 20%;
      text-align: center;
    }
    .col-5 {
      width: 20%;
      text-align: center;
    }
  }

  .table-body {
    flex: 1;
    overflow-y: hidden;
    overflow-x: hidden;
    position: relative;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    // 滚动内容容器
    .scroll-wrapper {
      overflow-y: hidden;

      &.is-animating {
        animation: scroll-up 20s linear infinite;
      }
    }

    @keyframes scroll-up {
      0% {
        transform: translateY(0);
      }
      100% {
        // 滚动一半高度（因为数据复制了一份）
        transform: translateY(-50%);
      }
    }

    &:hover .scroll-wrapper.is-animating {
      animation-play-state: paused;
    }

    .table-row {
      display: flex;
      height: 42px;
      line-height: 42px;
      padding: 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      font-size: 18px;
      color: #fff;
      transition: background 0.3s;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
      }

      .col-1 {
        width: 20%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.hospital-name {
          cursor: pointer;
          color: #00cdff;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .col-2 {
        width: 20%;
        text-align: center;
        // color: #67c23a;
      }

      .col-3 {
        width: 20%;
        text-align: center;
        // color: #409EFF;
      }

      .col-4 {
        width: 20%;
        text-align: center;
        // color: #e6a23c;
      }

      .col-5 {
        width: 20%;
        text-align: center;
        // color: #f56c6c;
      }
    }

    .empty-tip {
      text-align: center;
      padding: 30px 0;
      color: #8e9eae;
      font-size: 18px;
    }
  }
}
</style>

